export const HOME = {
  emergentLink: "home-emergent-link",
};

export const NAV = {
  root: "site-nav",
  logo: "nav-logo",
  linkAbout: "nav-link-about",
  linkProcess: "nav-link-process",
  linkFounder: "nav-link-founder",
  linkTestimonials: "nav-link-testimonials",
  linkFAQ: "nav-link-faq",
  ctaBook: "nav-book-session-button",
};

export const HERO = {
  badgeFree: "hero-free-slots-badge",
  primaryCta: "hero-book-session-button",
  secondaryCta: "hero-take-assessment-button",
};

export const BOOKING = {
  form: "booking-form",
  name: "booking-name-input",
  email: "booking-email-input",
  phone: "booking-phone-input",
  grade: "booking-grade-input",
  sessionType: "booking-session-type-select",
  message: "booking-message-input",
  submit: "booking-submit-button",
  successAlert: "booking-success-alert",
  spotsRemaining: "booking-spots-remaining",
};

export const FAQ = {
  root: "faq-section",
  item: (i) => `faq-item-${i}`,
};

export const ADMIN = {
  loginEmail: "admin-login-email",
  loginPassword: "admin-login-password",
  loginSubmit: "admin-login-submit",
  logout: "admin-logout-button",

  // Tabs
  tabBranding: "admin-tab-branding",
  tabHero: "admin-tab-hero",
  tabAbout: "admin-tab-about",
  tabProcess: "admin-tab-process",
  tabDiff: "admin-tab-diff",
  tabFounder: "admin-tab-founder",
  tabTestimonials: "admin-tab-testimonials",
  tabBookingCopy: "admin-tab-booking-copy",
  tabFAQ: "admin-tab-faq",
  tabFooter: "admin-tab-footer",
  tabGallery: "admin-tab-gallery",
  tabPricing: "admin-tab-pricing",
  tabBookings: "admin-tab-bookings",

  // Save buttons (one per tab)
  saveBranding: "admin-save-branding-button",
  saveHero: "admin-save-hero-button",
  saveAbout: "admin-save-about-button",
  saveProcess: "admin-save-process-button",
  saveDiff: "admin-save-diff-button",
  saveFounder: "admin-save-founder-button",
  saveTestimonials: "admin-save-testimonials-button",
  saveBookingCopy: "admin-save-booking-copy-button",
  saveFAQ: "admin-save-faq-button",
  saveFooter: "admin-save-footer-button",
  saveGallery: "admin-save-gallery-button",
  savePricing: "admin-save-pricing-button",
  exportBookingsCsv: "admin-export-bookings-csv",

  // Compat (legacy iter-2 IDs still used by tests)
  tabContent: "admin-tab-branding",
  saveContent: "admin-save-branding-button",

  addTestimonial: "admin-add-testimonial-button",
  deleteTestimonial: (i) => `admin-delete-testimonial-${i}`,
  deleteBooking: (i) => `admin-delete-booking-${i}`,
  uploadLogo: "admin-upload-logo",
  uploadFounder: "admin-upload-founder-image",
  uploadHero1: "admin-upload-hero-primary",
  uploadHero2: "admin-upload-hero-secondary",
};
